import { ButtonStyle, ModalActionTypes } from '@acorns/web-components'
import { FormikErrors, FormikTouched } from 'formik'
import { pathOr } from 'ramda'
import * as yup from 'yup'

import AlertBadgePath from 'assets/icons/alert-badge.png'
import trackEvent from 'utils/analytics/trackEvent'

export const getTouchedErrors = <FormValues>(
  errors: FormikErrors<FormValues>,
  touched: FormikTouched<FormValues>,
) => {
  const fieldNames = Object.keys(errors)

  return fieldNames.reduce((accumulator, fieldName) => {
    const errorMessage = errors[fieldName]
    const isTouched = !!touched[fieldName]

    return !!errorMessage && isTouched
      ? { ...accumulator, [fieldName]: errorMessage }
      : { ...accumulator, [fieldName]: '' }
  }, {}) as FormikErrors<FormValues>
}

yup.addMethod(yup.string, 'maxWordCount', function(max, message) {
  return this.test('maxWordCount', message, function(value) {
    const { path, createError } = this
    if (typeof value === 'string') {
      if (value.trim().split(' ').length > max) {
        return createError({ path, message })
      }
    }
    return true
  })
})

export const parseGraphQLError = error => {
  let errorCode
  if (error.graphQLErrors) {
    // Obtain error code from GraphQL response
    errorCode = pathOr(
      null,
      ['graphQLErrors', 0, 'extensions', 'response', 'body', 'errors', 0],
      error,
    )
  } else {
    // Obtain error from REST response
    errorCode = pathOr(null, ['response', 'data', 'errors', 0], error)
  }
  return errorCode
}

export const displayErrorModal = (
  { showErrorModal, promptUser }: props,
  errorCode,
  errorCodeMap,
  eventDetails?: Record<string, string>,
) => {
  if (!errorCode) {
    return
  }

  const promptDetails = errorCodeMap[errorCode]
  if (promptDetails) {
    const { title, message, actions } = promptDetails

    showErrorModal({
      buttonStyle: ButtonStyle.column,
      image: null,
      title,
      message,
      actions,
    })
    trackEvent('Container Viewed', {
      eventData: {
        object_name: eventDetails?.objectName || 'registration.error',
        type: 'container_viewed',
        event_text: 'Container Viewed',
        screen: eventDetails?.screen || title,
        error: errorCode,
      },
    })
  } else {
    showErrorModal({
      message: 'It looks like something went wrong.',
      title: 'Oops!',
      image: AlertBadgePath,
      actions: [
        {
          type: ModalActionTypes.primary,
          label: 'OK',
        },
      ],
    })
  }
}
